import React from "react";
import { Tag } from "antd";
import { getColorByString } from "../utils/colorUtils";
import { AirplaneIcon } from "../components/icons/SvgIcons";

/**
 * 飞机标签组件
 * @param {Object} props - 组件属性
 * @param {string} props.registration - 飞机注册号
 * @param {Object} props.style - 额外的样式属性
 * @param {Object} props.tagProps - 传递给Tag组件的额外属性
 * @returns {React.ReactNode} - 返回飞机标签组件
 */
const AircraftTag = ({ registration, style = {}, tagProps = {} }) => {
    if (!registration || registration === "未分配" || registration === "未知") {
        return <span>{registration || "未分配"}</span>;
    }

    const borderColor = getColorByString(registration);

    return (
        <Tag
            style={{
                backgroundColor: "#f9f9f9",
                border: `1px solid ${borderColor}`,
                color: "#333",
                ...style,
            }}
            {...tagProps}
        >
            <AirplaneIcon color={borderColor} />
            {registration}
        </Tag>
    );
};

export default AircraftTag;
